module.exports = __webpack_public_path__ + "static/media/decision-tree.b512ddf4.svg";